import { call, put, takeEvery } from "redux-saga/effects";
import { dmLoaiLopTinChiApi } from "../../../api/category/dmLoaiLopTinChiApi";
import { IDmLoaiLopTinChi } from "../../../model/respone/category/IDmLoaiLopTinChi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDmLoaiLopTinChiActionIds,
  IDmLoaiLopTinChiActionTypes,
} from "../../action-types/category/IDmLoaiLopTinChiActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.category.dmLoaiLopTinChi;

export function* dmLoaiLopTinChiSaga(): any {
  yield takeEvery(eDmLoaiLopTinChiActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmLoaiLopTinChiActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmLoaiLopTinChiActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(dmLoaiLopTinChiApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDmLoaiLopTinChiActionTypes): any {
  const payload = action.payload as IDmLoaiLopTinChi;
  let res: IBaseRespone;
  if (payload.loai_lop > 0) {
    res = yield call(dmLoaiLopTinChiApi.Update, payload);
  } else {
    res = yield call(dmLoaiLopTinChiApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IDmLoaiLopTinChiActionTypes): any {
  const loai_lop = action.payload as number;
  const res: IBaseRespone = yield call(dmLoaiLopTinChiApi.Delete, loai_lop);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}

